export const NodeTypes = {
  amazonRDSReader: {
    type: 'amazonRDSReader',
    title: 'Amazon RDS Reader',
  },
  amazonRDSWriter: {
    type: 'amazonRDSWriter',
    title: 'Amazon RDS Writer',
  },
  amazonRedshiftReader: {
    type: 'amazonRedshiftReader',
    title: 'Amazon Redshift Reader',
  },
  amazonRedshiftWriter: {
    type: 'amazonRedshiftWriter',
    title: 'Amazon Redshift Writer',
  },
  s3Reader: {
    type: 's3Reader',
    title: 'S3 Reader Node',
  },
  s3Writer: {
    type: 's3Writer',
    title: 'S3 Writer Node',
  },
  amazonSESConnector: {
    type: 'amazonSESConnector',
    title: 'Amazon SES Connector Node',
  },
  awsElasticsearchReader5x: {
    type: 'awsElasticsearchReader5x',
    title: 'Amazon Elastic Search Reader 5x Node',
  },
  zoomReader: {
    type: 'zoomReader',
    title: 'Zoom Reader Node',
  },
  zoomWriter: {
    type: 'zoomWriter',
    title: 'Zoom Writer Node',
  },
  zoomGraphQLReader: {
    type: 'zoomGraphQLReader',
    title: 'Zoom GraphQL Reader Node',
  },
  json: {
    type: 'json',
    title: 'Json Node',
  },
  ethosReader: {
    type: 'ethosReader',
    title: 'Ethos Reader Node',
  },
  ethosWriter: {
    type: 'ethosWriter',
    title: 'Ethos Writer Node',
  },
  ethosV2AsyncReader: {
    type: 'ethosV2AsyncReader',
    title: 'Ethos V2 Async Reader Node',
  },
  ethosV2Reader: {
    type: 'ethosV2Reader',
    title: 'Ethos V2 Reader Node',
  },
  ethosGraphQLReader: {
    type: 'ethosGraphQLReader',
    title: 'Ethos GraphQL Reader Node',
  },
  salesforceReader: {
    type: 'salesforceReader',
    title: 'SalesForce Reader Node',
  },
  salesforceV2Reader: {
    type: 'salesforceV2Reader',
    title: 'SalesForce V2 Reader Node',
  },
  salesforceWriter: {
    type: 'salesforceWriter',
    title: 'SalesForce Writer Node',
  },
  salesforceBulkWriter: {
    type: 'salesforceBulkWriter',
    title: 'SalesForce Bulk Writer Node',
  },
  salesforceBulkReader: {
    type: 'salesforceBulkReader',
    title: 'SalesForce Bulk Reader Node',
  },
  paycomReader: {
    type: 'paycomReader',
    title: 'Paycom Reader Node',
  },
  paycomWriter: {
    type: 'paycomWriter',
    title: 'Paycom Writer Node',
  },
  httpReader: {
    type: 'httpReader',
    title: 'HTTP Reader Node',
  },
  httpWriter: {
    type: 'httpWriter',
    title: 'HTTP Writer Node',
  },
  httpV2Reader: {
    type: 'httpV2Reader',
    title: 'HTTP V2 Reader Node',
  },

  sqlServer: {
    type: 'sqlServer',
    title: 'SQL Server Node',
  },
  infosilemReader: {
    type: 'infosilemReader',
    title: 'Infosilem Reader Node',
  },
  localFileReader: {
    type: 'localFileReader',
    title: 'Local File Reader Node',
  },
  localFileWriter: {
    type: 'localFileWriter',
    title: 'Local File Writer Node',
  },
  localFileImporter: {
    type: 'localFileImporter',
    title: 'Local File Importer Node',
  },
  graphqlReader: {
    type: 'graphqlReader',
    title: 'GraphQL Reader Node',
  },
  sftpReader: {
    type: 'sftpReader',
    title: 'SFTP Reader Node',
  },
  sftpWriter: {
    type: 'sftpWriter',
    title: 'SFTP Writer Node',
  },
  lingkWriter: {
    type: 'lingkWriter',
    title: 'Lingk Writer Node',
  },
  lingkAdapterReader: {
    type: 'lingkAdapterReader',
    title: 'Lingk Adapter Reader Node',
  },
  lingkAdapterWriter: {
    type: 'lingkAdapterWriter',
    title: 'Lingk Adapter Writer Node',
  },
  anthologyReader: {
    type: 'anthologyReader',
    title: 'Anthology Reader Node',
  },
  anthologyWriter: {
    type: 'anthologyWriter',
    title: 'Anthology Writer Node',
  },
  brightSpaceValenceApiReader: {
    type: 'brightSpaceValenceApiReader',
    title: 'BrightSpace Valence API Reader Node',
  },
  brightSpaceValenceApiWriter: {
    type: 'brightSpaceValenceApiWriter',
    title: 'BrightSpace Valence API Writer Node',
  },
  jdbcReader: {
    type: 'jdbcReader',
    title: 'JDBC Reader Node',
  },
  blackboardReader: {
    type: 'blackboardReader',
    title: 'Blackboard Reader Node',
  },
  blackboardWriter: {
    type: 'blackboardWriter',
    title: 'Blackboard Writer Node',
  },
  canvasReader: {
    type: 'canvasReader',
    title: 'Canvas Reader Node',
  },
  canvasWriter: {
    type: 'canvasWriter',
    title: 'Canvas Writer Node',
  },
  canvasGraphQLReader: {
    type: 'canvasGraphQLReader',
    title: 'Canvas GraphQL Reader Node',
  },
  colleagueReader: {
    type: 'colleagueReader',
    title: 'Colleague Reader Node',
  },
  colleagueWriter: {
    type: 'colleagueWriter',
    title: 'Colleague Writer Node',
  },
  microsoftCosmosDbReader: {
    type: 'microsoftCosmosDbReader',
    title: 'Microsoft Cosmos DB Reader Node',
  },
  microsoftCosmosDbV2Reader: {
    type: 'microsoftCosmosDbV2Reader',
    title: 'Microsoft Cosmos DB V2 Reader Node',
  },
  docuSignReader: {
    type: 'docuSignReader',
    title: 'Docusign Reader Node',
  },
  edfiReader: {
    type: 'edfiReader',
    title: 'EDFI Reader Node',
  },
  edfiWriter: {
    type: 'edfiWriter',
    title: 'EDFI Writer Node',
  },
  edReadyReader: {
    type: 'edReadyReader',
    title: 'EDREADY Reader Node',
  },
  element451Reader: {
    type: 'element451Reader',
    title: 'Element451 Reader Node',
  },
  element451Writer: {
    type: 'element451Writer',
    title: 'Element451 Writer Node',
  },
  googleSpreadsheetReader: {
    type: 'googleSpreadsheetReader',
    title: 'Google Spreadsheet Reader Node',
  },
  googleSpreadsheetWriter: {
    type: 'googleSpreadsheetWriter',
    title: 'Google Spreadsheet Writer Node',
  },
  googleBigQueryReader: {
    type: 'googleBigQueryReader',
    title: 'Google BigQuery Reader Node',
  },
  googleBigQueryWriter: {
    type: 'googleBigQueryWriter',
    title: 'Google BigQuery Writer Node',
  },
  leadSquaredReader: {
    type: 'leadSquaredReader',
    title: 'Lead Squared Reader Node',
  },
  leadSquaredWriter: {
    type: 'leadSquaredWriter',
    title: 'Lead Squared Writer Node',
  },
  learningStreamReader: {
    type: 'learningStreamReader',
    title: 'Learning Stream Reader Node',
  },
  learningStreamWriter: {
    type: 'learningStreamWriter',
    title: 'Learning Stream Writer Node',
  },
  logReader: {
    type: 'logReader',
    title: 'Log Reader Node',
  },
  moodleReader: {
    type: 'moodleReader',
    title: 'Moodle Reader Node',
  },
  moodleWriter: {
    type: 'moodleWriter',
    title: 'Moodle Writer Node',
  },
  peoplesoftReader: {
    type: 'peoplesoftReader',
    title: 'People Soft Reader Node',
  },
  peoplesoftWriter: {
    type: 'peoplesoftWriter',
    title: 'People Soft Writer Node',
  },

  // Tasks
  sftpOperationdirectoryList: {
    type: 'sftpOperationdirectoryList',
    title: 'SFTP Operation Directory Listing Task',
  },
  sftpOperationdeleteFile: {
    type: 'sftpOperationdeleteFile',
    title: 'SFTP Operation Delete File Task',
  },
  sftpOperationcopyFile: {
    type: 'sftpOperationcopyFile',
    title: 'SFTP Operation Copy File Task',
  },
  sftpOperationcopyFileToS3: {
    type: 'sftpOperationcopyFileToS3',
    title: 'SFTP Operation Copy File To S3 Task',
  },
  sftpOperationmoveFile: {
    type: 'sftpOperationmoveFile',
    title: 'SFTP Operation Move File Task',
  },
  fileOperationdeleteFileFromS3: {
    type: 'fileOperationdeleteFileFromS3',
    title: 'File Operation Delete File From S3 Task',
  },
  fileOperationappend: {
    type: 'fileOperationappend',
    title: 'File Operation Append Task',
  },
  fileOperations3DirectoryList: {
    type: 'fileOperations3DirectoryList',
    title: 'S3 Directory List Task',
  },
  excelReader: {
    type: 'excelReader',
    title: 'Excel Reader Node',
  },
  excelWriter: {
    type: 'excelWriter',
    title: 'Excel Writer Node',
  },
  textReader: {
    type: 'textReader',
    title: 'Text Reader Node',
  },
  textWriter: {
    type: 'textWriter',
    title: 'Text Writer Node',
  },
  jsonArrayWriter: {
    type: 'jsonArrayWriter',
    title: 'JSON Array Writer Node',
  },
  jsonReader: {
    type: 'jsonReader',
    title: 'JSON Reader Node',
  },
  xmlReader: {
    type: 'xmlReader',
    title: 'XML Reader Node',
  },
  xmlWriter: {
    type: 'xmlWriter',
    title: 'XML Writer Node',
  },
  delimitedReader: {
    type: 'delimitedReader',
    title: 'Delimited Reader Node',
  },
  delimitedWriter: {
    type: 'delimitedWriter',
    title: 'Delimited Writer Node',
  },
  dataOperationbatch: {
    type: 'dataOperationbatch',
    title: 'Data Operation Batch Task',
  },
  dataOperationdedup: {
    type: 'dataOperationdedup',
    title: 'Data Operation Dedup Task',
  },
  oDataReader: {
    type: 'oDataReader',
    title: 'OData Reader Node',
  },
  httpXmlConnector: {
    type: 'httpXmlConnector',
    title: 'HTTP XML Connector Node',
  },
  jdbcWriter: {
    type: 'jdbcWriter',
    title: 'JDBC Writer Node',
  },
};

export const NODE_TYPES = {
  salesforceWriter: 'salesforceWriter',
  salesforceReader: 'salesforceReader',
  salesforceV2Reader: 'salesforceV2Reader',
  salesforceBulkWriter: 'salesforceBulkWriter',
  salesforceBulkReader: 'salesforceBulkReader',
  amazonRDSReader: 'amazonRDSReader',
  amazonRDSWriter: 'amazonRDSWriter',
  amazonRedshiftReader: 'amazonRedshiftReader',
  amazonRedshiftWriter: 'amazonRedshiftWriter',
  s3Reader: 's3Reader',
  s3Writer: 's3Writer',
  amazonSESConnector: 'amazonSESConnector',
  awsElasticsearchReader5x: 'awsElasticsearchReader5x',
  zoomReader: 'zoomReader',
  zoomWriter: 'zoomWriter',
  zoomGraphQLReader: 'zoomGraphQLReader',
  json: 'json',
  ethosReader: 'ethosReader',
  ethosWriter: 'ethosWriter',
  ethosV2AsyncReader: 'ethosV2AsyncReader',
  ethosV2Reader: 'ethosV2Reader',
  ethosGraphQLReader: 'ethosGraphQLReader',
  httpReader: 'httpReader',
  httpWriter: 'httpWriter',
  httpV2Reader: 'httpV2Reader',
  sqlServer: 'sqlServer',
  infosilemReader: 'infosilemReader',
  localFileReader: 'localFileReader',
  localFileWriter: 'localFileWriter',
  localFileImporter: 'localFileImporter',
  graphqlReader: 'graphqlReader',
  sftpReader: 'sftpReader',
  sftpWriter: 'sftpWriter',
  lingkWriter: 'lingkWriter',
  lingkAdapterReader: 'lingkAdapterReader',
  lingkAdapterWriter: 'lingkAdapterWriter',
  anthologyReader: 'anthologyReader',
  anthologyWriter: 'anthologyWriter',
  brightSpaceValenceApiReader: 'brightSpaceValenceApiReader',
  brightSpaceValenceApiWriter: 'brightSpaceValenceApiWriter',
  jdbcReader: 'jdbcReader',
  blackboardReader: 'blackboardReader',
  blackboardWriter: 'blackboardWriter',
  canvasReader: 'canvasReader',
  canvasWriter: 'canvasWriter',
  canvasGraphQLReader: 'canvasGraphQLReader',
  colleagueReader: 'colleagueReader',
  colleagueWriter: 'colleagueWriter',
  microsoftCosmosDbReader: 'microsoftCosmosDbReader',
  microsoftCosmosDbV2Reader: 'microsoftCosmosDbV2Reader',
  docuSignReader: 'docuSignReader',
  edfiReader: 'edfiReader',
  edfiWriter: 'edfiWriter',
  edReadyReader: 'edReadyReader',
  element451Reader: 'element451Reader',
  element451Writer: 'element451Writer',
  googleSpreadsheetReader: 'googleSpreadsheetReader',
  googleSpreadsheetWriter: 'googleSpreadsheetWriter',
  googleBigQueryReader: 'googleBigQueryReader',
  googleBigQueryWriter: 'googleBigQueryWriter',
  leadSquaredReader: 'leadSquaredReader',
  leadSquaredWriter: 'leadSquaredWriter',
  learningStreamReader: 'learningStreamReader',
  learningStreamWriter: 'learningStreamWriter',
  moodleReader: 'moodleReader',
  moodleWriter: 'moodleWriter',
  paycomReader: 'paycomReader',
  paycomWriter: 'paycomWriter',
  peoplesoftReader: 'peoplesoftReader',
  peoplesoftWriter: 'peoplesoftWriter',
  logReader: 'logReader',
  oDataReader: 'oDataReader',
  create: 'create',
  select: 'select',
  insert: 'insert',
  update: 'update',
  printCommand: 'printCommand',
  printSchemaCommand: 'printSchemaCommand',
  refreshCommand: 'refreshCommand',
  sleepCommand: 'sleepCommand',
  stopCommand: 'stopCommand',
  stopifzeroCommand: 'stopifzeroCommand',
  validateCommand: 'validateCommand',
  executeCommand: 'executeCommand',
  selectCommand: 'selectCommand',
  insertCommand: 'insertCommand',
  updateCommand: 'updateCommand',
  deleteCommand: 'deleteCommand',
  defaultCommand: 'defaultCommand',
  excelReader: 'excelReader',
  excelWriter: 'excelWriter',
  jsonArrayWriter: 'jsonArrayWriter',
  jsonReader: 'jsonReader',
  textReader: 'textReader',
  textWriter: 'textWriter',
  xmlReader: 'xmlReader',
  xmlWriter: 'xmlWriter',
  delimitedReader: 'delimitedReader',
  delimitedWriter: 'delimitedWriter',
  sftpOperationdirectoryList: 'sftpOperationdirectoryList',
  sftpOperationdeleteFile: 'sftpOperationdeleteFile',
  sftpOperationcopyFile: 'sftpOperationcopyFile',
  sftpOperationcopyFileToS3: 'sftpOperationcopyFileToS3',
  sftpOperationdeleteFileFromS3: 'sftpOperationdeleteFileFromS3',
  sftpOperationmoveFile: 'sftpOperationmoveFile',
  dataOperationbatch: 'dataOperationbatch',
  dataOperationdedup: 'dataOperationdedup',
  fileOperationappend: 'fileOperationappend',
  fileOperationdeleteFileFromS3: 'fileOperationdeleteFileFromS3',
  fileOperations3DirectoryList: 'fileOperations3DirectoryList',
  httpXmlConnector: 'httpXmlConnector',
  jdbcWriter: 'jdbcWriter',
};
